import { createClasses } from '@repo/shared-theme-utils/create-classes'

// --------------------------------------------------------------------------------------------- //

export const svgColorClasses = {
  root: createClasses('svg__color__root')
}
